import moment from "moment";

export const formatDateLong = (date: Date) => {
  let returnDate = "";
  if (date) {
    const format = moment.localeData().longDateFormat("LL");
    returnDate = moment(date).format(format);
  }
  return returnDate;
};
